let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5E05A")).then(() => parcelRequire('dmhsc'));